export enum DataSource {
    CURRENT_PATIENT = 'current_patient',
    CPPOPT_ANALYSIS = 'cppopt_analysis'
}